import { render, staticRenderFns } from "./update.vue?vue&type=template&id=4e560979&scoped=true&lang=pug"
import script from "./update.vue?vue&type=script&lang=ts"
export * from "./update.vue?vue&type=script&lang=ts"
import style0 from "./update.vue?vue&type=style&index=0&id=4e560979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e560979",
  null
  
)

export default component.exports